/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import { ListGroupItem } from 'reactstrap';
import { WeverCoreContext } from "../../../../services/core";
import Icon from "../../../common/icon";
var MenuResponse = function MenuResponse(_ref) {
  var key = _ref.key,
    response = _ref.response,
    onSelect = _ref.onSelect;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  return /*#__PURE__*/React.createElement(ListGroupItem, {
    key: key,
    className: "text-dark border-0 py-1 mouse-cursor",
    onClick: function onClick() {
      return onSelect(response);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-1 text-wever-pink"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "caret-right"
  })), response.name[locale]);
};
export default MenuResponse;